module.exports = __webpack_public_path__ + "img/img16.03423a6d.png";